








import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { uri } from "@/config/map/map.config.json";

import L from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { Icon } from "leaflet";

type D = Icon.Default & {
  _getIconUrl?: string;
};
delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

@Component({
  name: "MapOneDot",
  components: {
    "l-map": LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
  },
})
export default class MapOneDot extends Vue {
  @Prop({ type: Array, default: () => [] }) LonLat!: Array<number>;

  url = uri;
  attribution =
    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  zoom = 11;
  center: number[] = [55, 37];

  map!: L.Map;

  $refs!: {
    map: LMap;
  };

  get dot(): number[] | null {
    if (this.LonLat && this.LonLat.length === 2)
      return [this.LonLat[1], this.LonLat[0]];
    return null;
  }

  @Watch("LonLat")
  updateCenter(): void {
    if (this.dot) this.center = this.dot;
  }

  mounted(): void {
    this.$nextTick(() => {
      this.map = this.$refs.map.mapObject;
      this.map.attributionControl.setPrefix("Leaflet");
    });
    this.updateCenter();
  }
}
